import React, { useState } from "react";
import { useEffect } from "react";
import Plus from "../assets/images/plus.svg"; // Replace with correct path
import Minus from "../assets/images/minus.png";

const CommonCollapsibleTable = ({ data = [], header = [] }) => {
  const [openSections, setOpenSections] = useState(() => {
    if (data.length > 0 && data[0].types.length > 0) {
      return { "0-0": true }; // Open the first section by default
    }
    return {};
  });

  const [totalbrand, settotalbrand] = useState(0);
  const toggleSection = (key) => {
    setOpenSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  if (!data.length) {
    return (
      <div className="text-center mt-6 text-gray-500">
        No comparison data available.
      </div>
    );
  }

  return (
    <div className="table-responsive dahboardTable mt-4">
      <table
        cellPadding={10}
        cellSpacing={10}
        style={{
          width: "100%",
        }}
      >
        <thead className="head1">
          <tr>
            <th style={{ fontSize: "20px", fontWeight: 400 }}>
              Compare by Brand:
            </th>
            <th></th>
            {header.map((k, index) => (
              <th colSpan={2} key={index} className="text-center">
                {k.name.charAt(0).toUpperCase() + k.name.slice(1)}
              </th>
            ))}
          </tr>
        </thead>
        <thead className="thead2">
          <tr
            style={{
              background: "#F8F8F8",
              color: "#666666",
              fontSize: "12px",
              fontWeight: 400,
            }}
          >
            <th>Material</th>
            <th>Date</th>

            {header.map((item, index) => (
              <React.Fragment key={index}>
                <th>Price</th>
                <th>Speed</th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((section, idx) => (
            <React.Fragment key={idx}>
              <tr>
                <td colSpan={15} style={{ borderBottom: 0 }}>
                  {section.material}
                </td>
              </tr>
              {section.types.map((typeObj, typeIdx) => {
                const key = `${idx}-${typeIdx}`;
                const isOpen = openSections[key];

                return (
                  <React.Fragment key={key}>
                    <tr
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleSection(key)}
                    >
                      <td
                        colSpan={15}
                        style={{ borderBottom: "1px solid #EFF2F9" }}
                      >
                        <img
                          src={isOpen ? Minus : Plus}
                          alt=""
                          style={{ width: "25px", marginRight: "8px" }}
                        />
                        {typeObj.type}
                      </td>
                    </tr>
                    {isOpen &&
                      typeObj.rows.map((row, rowIdx) => (
                        <tr key={rowIdx}>
                          {row.map((cell, cellIdx) => (
                            <td
                              key={cellIdx}
                              style={cell === "NA" ? { fontSize: "0.7em" } : {}}
                            >
                              {cell === null || cell === undefined || cell === "" ? 0 : cell}
                            </td>
                          ))}
                        </tr>
                      ))}
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CommonCollapsibleTable;
